import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
var SimpleLightbox = require('simple-lightbox');
import 'simple-lightbox/dist/simpleLightbox.css';

export function blockPublicationsHome() {
    document.addEventListener('DOMContentLoaded', function () {

        let splidePublicationsHome = new Splide('.splide_prod', {
            arrows: false,
            type: 'loop',
            perPage: 1,
        });
        // splidePublicationsHome.mount();
        if (window.innerWidth < 960) {
            splidePublicationsHome.mount();
        }
        else {

        }



        // const blocks = document.querySelectorAll('.mainBanner__sliders');

        // blocks.forEach(block => {
        //     new Splide(block, {
        //         arrows: false,
        //         cover: true,
        //         type: "loop",
        //         perPage: 1,
        //         perMove: 1,
        //     }).mount();
        // })
    })
}